const getOffsetTop = (element) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    // eslint-disable-next-line no-param-reassign
    element = element.offsetParent;
  }
  return offsetTop;
};

// Close all tabs
const closeTabContents = (tabLinks, tabContent) => {
  tabLinks.forEach((elem) => {
    elem.classList.remove('is-active');
  });
  tabContent.forEach((contentElem) => {
    contentElem.classList.remove('is-active');
  });
};

attachEvent('[data-tab-link]', 'click', (ev) => {
  const parentElem = ev.target.closest('.tabs-module');
  const tabLinks = parentElem.querySelectorAll('[data-tab-link]');
  const tabContent = parentElem.querySelectorAll('.tabs-module__tab-content');

  // Scroll To Content
  const tabContentWrapper = parentElem.querySelector('.tabs-module__tab-content-wrapper');

  if (headerEle) {
    const topOffset = getOffsetTop(tabContentWrapper) - (windowWidth() > breakpointMd ? headerEle.offsetHeight : 0);
    scrollToSmoothly(topOffset);
  }

  const targetValue = ev.target.getAttribute('href');
  window.history.pushState({urlPath:window.location.href}, null, `${targetValue}`);
  closeTabContents(tabLinks, tabContent);
  ev.target.classList.add('is-active');
  document.querySelector(targetValue).classList.add('is-active');

  ev.preventDefault();
});

if (window.location.hash) {
  const tabToClick = document.querySelector(`[href='${window.location.hash}']`);
  if (tabToClick) {
    tabToClick.click();
  }
}
